import { Navigate } from 'react-router-dom';
import useRedux from 'redux/useRedux';

interface CheckPermissionRouteProps {
  feature_name: string;
  permission: 'is_view' | 'is_edit' | 'is_add' | 'is_delete';
  children: any;
}

const CheckPermissionRoute = ({
  feature_name,
  children,
  permission,
}: CheckPermissionRouteProps) => {
  const {
    storeState: { Auth },
  } = useRedux();

  if (Auth && Auth.status === 'success') {
    if (Auth.data && Auth.data && Auth.data.features_and_permissions) {
      let check = Auth.data.features_and_permissions.some(
        (f) =>
          f.feature_name === feature_name && eval(`f.${permission}`) === true
      );

      if (check) {
        return children;
      }
    }
  }

  return <Navigate to="/404" replace />;
};

export default CheckPermissionRoute;
